<template>
  <div class="floating-download-qr" aria-label="扫码下载久朋APP">
    <img :src="qrImg" class="qr-img" alt="久朋APP二维码" />
    <div class="qr-text">
      <div class="qr-title">扫码下载久朋APP</div>

      <div class="qr-version">V1.0.0</div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingDownloadQr',
  data() {
    return {
      qrImg: require('@/assets/images/game_qrcode.png')
    }
  }
}
</script>

<style scoped>
.floating-download-qr {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  padding: 14px 14px 12px;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(10px);
}

.qr-img {
  width: 128px;
  height: 128px;
  object-fit: contain;
  border-radius: 10px;
  background: #fff;
}

.qr-text {
  text-align: center;
  color: #242424;
  line-height: 1.2;
}

.qr-title {
  font-size: 14px;
  font-weight: 600;
}

.qr-version {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
}

/* 仅 PC 展示：手机端隐藏 */
@media (max-width: 768px) {
  .floating-download-qr {
    display: none;
  }
}
</style>
